import { render, staticRenderFns } from "./OrderIdiom.vue?vue&type=template&id=070ab392&scoped=true&"
import script from "./OrderIdiom.vue?vue&type=script&lang=js&"
export * from "./OrderIdiom.vue?vue&type=script&lang=js&"
import style0 from "./OrderIdiom.vue?vue&type=style&index=0&id=070ab392&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070ab392",
  null
  
)

export default component.exports